export default __webpack_public_path__ + "static/media/austin-movie-gear.6c0a4f40.png";